import './App.css';
import { Main } from './Components/Main';
import { WelcomeCard } from './Components/WelcomeCard';
import { useStateValue } from './context/StateProvider';



function App() {
  const [{account}, dispatch] = useStateValue();


  

  return (
      <div className="App">
        {account ? <Main /> : <WelcomeCard />}
      </div>
  );
}

export default App;
